// LoginPage.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderOne from "../../header/HeaderOne";
import FooterOne from '../../footer/FooterOne';
import Breadcrumb from '../../components/BreadCurmb';

function RegisterPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
  
    const handleSubmit = (event) => {
      event.preventDefault();
      // Handle registration logic here
    };
  
    return (
      <> 
        <section className="contact-area pt-120 pb-90 pt-md-60 pb-md-60 pt-xs-60 pb-xs-60" style={{marginTop:'1%'}}>
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="section-title mb-60">
                  <p className="fs-14 lh-1 mb-15">Join Us</p>
                  <h2 className="sect-title lh-1">Create a TextLink Account</h2>
                </div>
                <form onSubmit={handleSubmit} className="contact-form">
                  <input type="email" placeholder="Email *" value={email} onChange={(e) => setEmail(e.target.value)} />
                  <input type="password" placeholder="Password *" value={password} onChange={(e) => setPassword(e.target.value)}  style={{marginTop:20}}/>
                  <input type="password" placeholder="Confirm Password *" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} style={{marginTop:20}} />
                  <button type="submit" className="theme_btn theme_btn3"style={{marginTop:20}}>Register</button>
                </form>
                <div className="mt-15">
                  <Link to="/login"  style={{marginTop:20}}>Already have an account? Login</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
  
  export default RegisterPage;